/*
 * RUFU: レコメンド（Search & Discovery の related）＋カート追加ボタン
 *
 * <reco-products product-ids="1,2" exclude-ids="1,2" limit="4" [exclude-sale]>
 *   商品IDごとに /recommendations/products?intent=related&section_id=reco-items を取得し、
 *   重複とカート内商品を除いて limit 件を [data-reco-list] に差し込む。0件なら要素ごと隠す。
 *   exclude-sale が付いていれば、SALE品（カードの data-reco-sale。タグ「SALE」）も除く。
 *
 * <reco-add-button>
 *   中の form（/cart/add）を Ajax で送信する。テーマの product-form と違い、cart_type=page でも
 *   カートページへ遷移しない（商品ページで2点続けて追加できるようにするため）。
 *   - カートページ上: 追加後にページを再読み込み（Aíam/eimy のカートは Liquid 描画のため）
 *   - それ以外: cart:change を発火（カートアイコンの件数・カートドロワーが更新される）
 *
 * レコメンド経由の売上の計測
 *   - 商品行のプロパティ _reco: レコメンドから入った商品に付く。値は「枠_経路」
 *       枠: product（商品ページ）/ cart（カートページ）/ drawer（カートドロワー）
 *       経路: add（カードのボタンで追加）/ quick（カードからクイック購入）/ click（カードから商品ページへ移って追加）
 *     先頭が _ のプロパティはカート・チェックアウトでお客様に見えない（line-item の表示で除外済み）。注文の商品行には残る
 *   - カート属性 _reco_touched: レコメンド経由の商品を1点でも追加したカートに付く（注文単位で間接効果を測る用）
 *   - カート属性 _ab_reco: A/Bテストの群の印。このテーマ（RUFU のレコメンドあり）は "reco"。カートに商品が入ったら付ける
 *     （公開中テーマ＝対照は snippets/rufu-ab-mark.liquid が "control" を付ける）。カートを通らない注文（Buy it now など）には付かない
 *   click は、カードのリンクを押した商品IDを localStorage に24時間残し、その商品ページでカートに入れたときに付ける。
 *   テーマ内のカート追加は経路が複数ある（product-form・main-product の独自処理・追従バー）ため、/cart/add.js への fetch で付ける
 */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const RECO_PROP = 'properties[_reco]';
  const CLICK_KEY = 'rufu_reco_clicks';
  const CLICK_TTL = 24 * 60 * 60 * 1000;

  const readClicks = () => {
    try {
      const clicks = JSON.parse(localStorage.getItem(CLICK_KEY) || '{}');
      const now = Date.now();
      Object.keys(clicks).forEach((id) => { if (!clicks[id] || now - clicks[id].at > CLICK_TTL) delete clicks[id]; });
      return clicks;
    } catch (e) {
      return {};
    }
  };

  const saveClick = (productId, value) => {
    try {
      const clicks = readClicks();
      clicks[productId] = { value, at: Date.now() };
      localStorage.setItem(CLICK_KEY, JSON.stringify(clicks));
    } catch (e) {}
  };

  const contextOf = (el) => {
    const card = el.closest('[data-reco-context]');
    return (card && card.getAttribute('data-reco-context')) || 'product';
  };

  // カードのリンク（画像・商品名・商品ページへのボタン）を押したら、商品ページでの追加に click を付けるために残す
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-reco-card] a[href]');
    if (!link) return;
    const card = link.closest('[data-reco-card]');
    saveClick(card.getAttribute('data-product-id'), `${contextOf(card)}_click`);
  }, true);

  // カード内のフォーム（その場で追加・クイック購入）は、送信の前に hidden の _reco を入れる
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !form.closest('[data-reco-card]')) return;
    let input = form.querySelector(`input[name="${RECO_PROP}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = RECO_PROP;
      form.appendChild(input);
    }
    input.value = `${contextOf(form)}_${form.closest('reco-add-button') ? 'add' : 'quick'}`;
  }, true);

  // 商品ページ: レコメンドから来た商品なら、その商品のバリエーションIDに click の値を対応させる
  const clickedVariants = (() => {
    const map = new Map();
    const product = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!product) return map;
    const click = readClicks()[String(product.id)];
    if (!click) return map;
    (product.variants || []).forEach((v) => map.set(String(v.id), click.value));
    return map;
  })();

  // /cart/add.js の本文に _reco を足し、付いていれば追加の成功後にカート属性 _reco_touched を付ける
  const tagAddBody = (body) => {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (!body.has(RECO_PROP)) {
        const value = clickedVariants.get(String(body.get('id')));
        if (value) body.set(RECO_PROP, value);
      }
      return { body, value: body.get(RECO_PROP) };
    }
    if (typeof body !== 'string') return { body, value: null };

    let json = null;
    try { json = JSON.parse(body); } catch (e) {}
    if (json && typeof json === 'object') {
      let value = null;
      (Array.isArray(json.items) ? json.items : [json]).forEach((item) => {
        if (!item || typeof item !== 'object') return;
        item.properties = item.properties || {};
        if (!item.properties._reco && clickedVariants.has(String(item.id))) item.properties._reco = clickedVariants.get(String(item.id));
        value = value || item.properties._reco || null;
        if (!Object.keys(item.properties).length) delete item.properties;
      });
      return { body: JSON.stringify(json), value };
    }

    const params = new URLSearchParams(body);
    const tagged = tagAddBody(params);
    return { body: tagged.value ? params.toString() : body, value: tagged.value };
  };

  const AB_VALUE = 'reco';

  // value があれば _reco_touched も一緒に書く。_ab_reco は毎回書く
  const markCart = (value) => {
    const attributes = { _ab_reco: AB_VALUE };
    if (value) attributes._reco_touched = value;
    window.fetch(`${root}cart/update.js`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    }).catch(() => {});
  };

  // ページを開いたとき、商品が入っているのに群の印がなければ付ける（このファイルのない画面で追加された場合など）
  window.fetch(`${root}cart.js`).then((res) => res.json()).then((cart) => {
    if (cart.item_count > 0 && (!cart.attributes || cart.attributes._ab_reco !== AB_VALUE)) markCart(null);
  }).catch(() => {});

  if (!window.__rufuRecoFetch) {
    window.__rufuRecoFetch = true;
    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      let value = null;
      let isAdd = false;
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const method = ((init && init.method) || 'GET').toUpperCase();
        if (method === 'POST' && url.indexOf('/cart/add') !== -1 && init && init.body) {
          isAdd = true;
          const tagged = tagAddBody(init.body);
          init.body = tagged.body;
          value = tagged.value;
        }
      } catch (e) {}

      const promise = originalFetch.apply(this, arguments);
      if (!isAdd) return promise;
      return promise.then((response) => {
        if (response.ok) markCart(value);
        return response;
      });
    };
  }

  class RecoProducts extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      this.load();
    }

    async load() {
      const ids = (this.getAttribute('product-ids') || '').split(',').map((s) => s.trim()).filter(Boolean).slice(0, 3);
      const exclude = new Set((this.getAttribute('exclude-ids') || '').split(',').map((s) => s.trim()).filter(Boolean));
      const limit = parseInt(this.getAttribute('limit') || '4', 10);
      const excludeSale = this.hasAttribute('exclude-sale');
      const list = this.querySelector('[data-reco-list]');

      if (ids.length === 0 || !list) return this.hideSelf();

      // SALE品を外すときは、外した分を埋められるよう取得できる上限（10件）まで取る
      const fetchLimit = excludeSale ? 10 : Math.min(10, limit + exclude.size + 2);
      const responses = await Promise.all(ids.map(async (id) => {
        try {
          const res = await fetch(`${root}recommendations/products?product_id=${id}&limit=${fetchLimit}&intent=related&section_id=reco-items`, { priority: 'low' });
          if (!res.ok) return [];
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          return Array.from(doc.querySelectorAll('[data-reco-card]')).filter((card) => !(excludeSale && card.hasAttribute('data-reco-sale')));
        } catch (e) {
          return [];
        }
      }));

      // 商品ごとの結果を交互に並べる（1点目の関連商品だけで埋まらないように）
      const picked = [];
      const seen = new Set(exclude);
      const maxLen = Math.max(0, ...responses.map((r) => r.length));
      for (let i = 0; i < maxLen && picked.length < limit; i++) {
        for (const cards of responses) {
          const card = cards[i];
          if (!card) continue;
          const pid = card.getAttribute('data-product-id');
          if (seen.has(pid)) continue;
          seen.add(pid);
          picked.push(card);
          if (picked.length >= limit) break;
        }
      }

      if (picked.length === 0) return this.hideSelf();

      const suffix = `-${RecoProducts.counter = (RecoProducts.counter || 0) + 1}`;
      const context = this.getAttribute('context') || 'product';
      const hideAction = this.hasAttribute('hide-action');
      const nodes = picked.map((card) => {
        const node = document.importNode(card, true);
        node.setAttribute('data-reco-context', context);
        // 選択欄とカート追加ボタンを出さない枠（商品ページ）では、カードの下段ごと外す
        if (hideAction) node.querySelectorAll('.reco-card__action').forEach((el) => el.remove());
        node.querySelectorAll('[id^="reco-quick-buy-"]').forEach((el) => { el.id += suffix; });
        node.querySelectorAll('[aria-controls^="reco-quick-buy-"]').forEach((el) => { el.setAttribute('aria-controls', el.getAttribute('aria-controls') + suffix); });
        return node;
      });
      list.replaceChildren(...nodes);
      this.hidden = false;
      const wrapper = this.closest('[data-reco-wrapper]');
      if (wrapper) wrapper.hidden = false;
    }

    hideSelf() {
      this.hidden = true;
      const wrapper = this.closest('[data-reco-wrapper]');
      if (wrapper) wrapper.hidden = true;
    }
  }

  class RecoAddButton extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      // カード内の選択欄: 選んだバリエーションの画像に差し替え、追加済みの表示を戻す
      const select = this.form.querySelector('select[name="id"]');
      if (select) {
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const image = option && option.getAttribute('data-image');
          const card = this.closest('.reco-card');
          const img = card && card.querySelector('.reco-card__media img');
          if (image && img) {
            img.removeAttribute('srcset');
            img.src = image;
          }
          const button = this.form.querySelector('button[type="submit"]');
          const label = button && button.querySelector('[data-reco-label]');
          if (button && button.classList.contains('is-added')) {
            button.classList.remove('is-added');
            if (label && this.defaultLabel) label.textContent = this.defaultLabel;
            const message = this.querySelector('[data-reco-message]');
            if (message) message.classList.remove('is-visible');
          }
        });
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      const button = this.form.querySelector('button[type="submit"]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      button.setAttribute('aria-busy', 'true');
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

      const formData = new FormData(this.form);
      if (sections.length) {
        formData.set('sections', sections.join(','));
        formData.set('sections_url', `${root}variants/${formData.get('id')}`);
      }

      let response;
      let json = {};
      try {
        response = await fetch(`${root}cart/add.js`, { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        json = await response.json();
      } catch (e) {
        response = { ok: false };
      }
      button.removeAttribute('aria-busy');

      const message = this.querySelector('[data-reco-message]');
      if (!response.ok) {
        if (message) {
          message.textContent = json.description || this.getAttribute('error-text') || '';
          message.classList.add('is-visible');
        }
        return;
      }

      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }

      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = json.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart }
      }));

      // eimy のヘッダーはカート件数を数字で出す（cart-dot の中身を Liquid で描画）。テーマは表示/非表示しか切り替えないので数字も更新する
      document.querySelectorAll('cart-dot').forEach((el) => {
        if (/^\d+$/.test(el.textContent.trim())) el.textContent = cart.item_count;
      });

      button.classList.add('is-added');
      const label = button.querySelector('[data-reco-label]');
      if (label && !this.defaultLabel) this.defaultLabel = label.textContent;
      if (label) label.textContent = this.getAttribute('added-text') || label.textContent;
      if (message) message.classList.add('is-visible');
    }
  }

  if (!customElements.get('reco-products')) customElements.define('reco-products', RecoProducts);
  if (!customElements.get('reco-add-button')) customElements.define('reco-add-button', RecoAddButton);
})();
